var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FA9BE328-E25F-4676-908D-237F9D82A7D8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-21",
    transform: "translate(-647.000000, -978.000000)",
    fill: "#23293C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(160.000000, 970.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-(7)-copy-5",
    transform: "translate(487.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8498631,10.3499684 L12.6500316,10.3499684 L12.6500316,1.14992629 C12.6500316,0.515266385 12.1347652,0 11.4998947,0 C10.8652348,0 10.3499684,0.515266385 10.3499684,1.14992629 L10.3499684,10.3499684 L1.14992629,10.3499684 C0.515266385,10.3499684 0,10.8652348 0,11.4998947 C0,12.1347652 0.515266385,12.6500316 1.14992629,12.6500316 L10.3499684,12.6500316 L10.3499684,21.8498631 C10.3499684,22.4847336 10.8652348,23 11.4998947,23 C12.1347652,23 12.6500316,22.4847336 12.6500316,21.8498631 L12.6500316,12.6500316 L21.8498631,12.6500316 C22.4847336,12.6500316 23,12.1347652 23,11.4998947 C23,10.8652348 22.4847336,10.3499684 21.8498631,10.3499684 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.795bcc61ae258964ed6382ab9d806bb7.svg";
export { ForwardRef as ReactComponent };